import React from 'react';
import ReactQuill from 'react-quill';
// import Dropdown from 'react-dropdown';
import { PostToggleCard, CustomWidthCard } from '../../components';

//for  
const toolbarModule = {
  container: [
    [{ 'align': [] }],
    ['bold', 'italic', 'underline'],
    ['link', 'clean'],
  ],
};

const modulesQuill = {
  toolbar: toolbarModule
};

const formatsQuill = [
  'header', 'font', 'size',
  'bold', 'italic', 'underline', 'strike', 'blockquote',
  'list', 'bullet', 'indent', 'align',
  'link', 'image', 'background', 'color',
];

// let fontSize = [
//   { value: '10', label: '10px' },
//   { value: '12', label: '12px' },
//   { value: '13', label: '13px' },
//   { value: '14', label: '14px' },
//   { value: '16', label: '16px' },
//   { value: '18', label: '18px' },
//   { value: '20', label: '20px' },
//   { value: '22', label: '22px' },
//   { value: '24', label: '24px' },
//   { value: '26', label: '26px' },
//   { value: '28', label: '28px' },
// ];

const CollectorLayoutCard = ({
  cnf,
  handleCnfChange,
  handleEditorFocus,
  currLayout,
  arrLylt,
  currLayoutId,
  updateLayoutById,
  openIconModel,
  fnCheckFieldIsDisplayOrNot,
  widgetType
}) => {
  return (
    <div className="tabs-layout-content">
      <div className="card card-editor card-template">
        <div className="card-editor-block">
          <label className="card-editor-title">Layouts</label>
          <div className="template-list">
            {
              arrLylt && arrLylt.map((val, key) => {
                return (
                  <div className={val._id == currLayoutId ? 'theme-layout-item theme-block active' : 'theme-layout-item theme-block'} key={key} onClick={() => updateLayoutById(val._id)}>
                    <span className="theme-layout-name">{val.tn}</span>
                    <img src={val.iu} alt="theme" />
                  </div>
                );
              })
            }
          </div>
        </div>
      </div>

      <div className="card card-editor card-template mt-15">
        <div className="card-editor-block p-0">
          <label className="card-editor-title">Header</label>
          <div className="customize-list">
            {fnCheckFieldIsDisplayOrNot('header', currLayout) &&
              <div className="editor-field-list editor-toggle-fullwt editor-field-list editor-toggle editor-toggle-contentwt">
                {cnf && cnf.ihdr != undefined &&
                  <div className="editor-field-listrm mb-0 width10x">
                    <PostToggleCard
                      ttl={'Show header'}
                      fieldName={'ihdr'}
                      value={cnf.ihdr}
                      handleCnfChange={handleCnfChange} />
                  </div>
                }

                {(cnf.ihdr == true || widgetType !== 'automation_marketing') &&
                  <div className='width10x'>
                    {fnCheckFieldIsDisplayOrNot('cnf.tlsiicn', currLayout) && cnf && cnf.tlsiicn != undefined &&
                      <div className="customize-dropdown customize-showarrow">
                        <label className="label-title">Icon display</label>
                        <label className="switch">
                          <input type="checkbox" checked={cnf.tlsiicn} onChange={(e) => handleCnfChange('tlsiicn', e.target.checked)} />
                          <span className="slider round"></span>
                        </label>
                      </div>
                    }
                    {cnf && cnf.tlsiicn == true && cnf.tlsicn != undefined &&
                      <div className="editor-toggle customize-dropdown customize-isaction">
                        {widgetType === 'automation_marketing' ?
                          <label className="label-title">Logo</label>
                          :
                          <label className="label-title">Button logo</label>
                        }
                        <div className="browse-upload-part">
                          <div className="browse-upload-show">
                            <img className="browse-upload-img" src={cnf.tlsicn} alt="image" />
                          </div>
                          <label className="editor-browse editor-browse-uploadimg" onClick={() => openIconModel('tlsicn')}>
                            <svg htmlFor="input_file" xmlns="http://www.w3.org/2000/svg" width="13.578" height="13.438" viewBox="0 0 13.578 13.438">
                              <path id="Path_14240" data-name="Path 14240" d="M-14973.806-2683.62a.289.289,0,0,1-.274-.277v-.019a.394.394,0,0,1,.008-.057l.643-2.886,2.541,2.544-2.834.688a.327.327,0,0,1-.054.008Zm1.063-3.927,6.435-6.434,2.544,2.54-6.437,6.438Zm7.1-7.1,1.086-1.086a1.123,1.123,0,0,1,1.59,0l1.135,1.131a.872.872,0,0,1,0,1.229l-1.267,1.266Z" transform="translate(14974.58 2696.559)" fill="#3c4858" stroke="rgba(0,0,0,0)" strokeWidth="1" />
                            </svg>
                          </label>
                        </div>
                      </div>
                    }
                  </div>
                }
                {cnf && cnf.ihdr == true &&
                  <div>
                    {cnf.hdttxt != undefined &&
                      <div className="editor-input header-editor-ckeditor editor-header-title">
                        <label className="label-title">Title</label>
                        <ReactQuill value={cnf.hdttxt} className='editor-ckeditor-input hideEditor hdttxt' modules={modulesQuill} formats={formatsQuill}
                          onChange={(newValue, delta, source) => {
                            if (source === 'user') {
                              handleCnfChange('hdttxt', newValue);
                            }
                          }}
                          onFocus={() => {
                            handleEditorFocus('hdttxt');
                          }} />
                      </div>
                    }
                    {cnf.cptxt != undefined &&
                      <div className="editor-input header-editor-ckeditor editor-header-caption">
                        <label className="label-title">Caption</label>
                        <ReactQuill value={cnf.cptxt} className='editor-ckeditor-input hideEditor cptxt' modules={modulesQuill} formats={formatsQuill}
                          onChange={(newValue, delta, source) => {
                            if (source === 'user') {
                              handleCnfChange('cptxt', newValue);
                            }
                          }}
                          onFocus={() => {
                            handleEditorFocus('cptxt');
                          }} />
                      </div>
                    }
                  </div>
                }
              </div>
            }
            {fnCheckFieldIsDisplayOrNot('cnf.tlssndln', currLayout) && cnf && cnf.tlssndln != undefined &&
              <div className="editor-input header-editor-ckeditor editor-header-title">
                <ReactQuill value={cnf.tlssndln} className='editor-ckeditor-input hideEditor tlssndln tlsbg' modules={modulesQuill} formats={formatsQuill}
                  onChange={(newValue, delta, source) => {
                    if (source === 'user') {
                      handleCnfChange('tlssndln', newValue);
                    }
                  }}
                  onFocus={() => {
                    handleEditorFocus('tlssndln', currLayout.ltn);
                  }} />
              </div>
            }
            {cnf && cnf.tlsfstln != undefined &&
              <div className="editor-input header-editor-ckeditor editor-header-title editor-field-list">
                <ReactQuill value={cnf.tlsfstln} className='editor-ckeditor-input hideEditor tlsfstln tlsbg' modules={modulesQuill} formats={formatsQuill}
                  onChange={(newValue, delta, source) => {
                    if (source === 'user') {
                      handleCnfChange('tlsfstln', newValue);
                    }
                  }}
                  onFocus={() => {
                    handleEditorFocus('tlsfstln');
                  }} />
              </div>
            }

            {cnf && cnf.tlstrdln != undefined &&
              <div className="editor-input header-editor-ckeditor editor-header-title editor-field-list">
                <ReactQuill value={cnf.tlstrdln} className='editor-ckeditor-input hideEditor tlstrdln tlsbg' modules={modulesQuill} formats={formatsQuill}
                  onChange={(newValue, delta, source) => {
                    if (source === 'user') {
                      handleCnfChange('tlstrdln', newValue);
                    }
                  }}
                  onFocus={() => {
                    handleEditorFocus('tlstrdln', currLayout.ltn);
                  }} />
              </div>
            }
          </div>
        </div>
      </div>

      {cnf && (cnf.frmirwrnm != undefined ||
        cnf.frmirwreml != undefined ||
        cnf.frmirwrphn != undefined ||
        cnf.frmirtng != undefined ||
        cnf.frmirwtxt != undefined) &&
        <div className="card card-editor card-template mt-15">
          <div className="card-editor-block p-0">
            <label className="card-editor-title">Review form</label>
            <div className="customize-list">
              {cnf.frmirwrnm != undefined &&
                <PostToggleCard
                  className={'editor-toggle-contentwt editor-toggle-fullwt'}
                  ttl={'Show name input'}
                  fieldName={'frmirwrnm'}
                  value={cnf.frmirwrnm}
                  handleCnfChange={handleCnfChange}>
                  {cnf.frmirwrnm == true &&
                    <div>
                      {cnf.frmrwrnmlbl != undefined &&
                        <div className="editor-input header-editor-ckeditor editor-header-title editor-rowbdr-none mt-0">
                          <label className="label-title">Label for name</label>
                          <ReactQuill value={cnf.frmrwrnmlbl} className='editor-ckeditor-input hideEditor frmrwrnmlbl tlsbg' modules={modulesQuill} formats={formatsQuill}
                            onChange={(newValue, delta, source) => {
                              if (source === 'user') {
                                handleCnfChange('frmrwrnmlbl', newValue);
                              }
                            }}
                            onFocus={() => {
                              handleEditorFocus('frmrwrnmlbl');
                            }} />
                        </div>
                      }
                      <div className="editor-input header-editor-ckeditor editor-header-title mt-0">
                        <div className="input-ctalabel input-ctalabel-dicsnt">
                          <label className="label-title">Placeholder for name</label>
                          <input className='editor-input-content editor-input-fullwidth' type="text" value={cnf.frmrwrnmplchdr} onChange={(e) => handleCnfChange('frmrwrnmplchdr', e.target.value)}></input>
                        </div>
                      </div>
                    </div>
                  }
                </PostToggleCard>
                // <div className="editor-toggle customize-dropdown customize-showarrow editor-rowbdr-none">
                //   <label className="label-title">Show name input</label>
                //   <label className="switch">
                //     <input type="checkbox" checked={cnf.frmirwrnm} onChange={(e) => handleCnfChange('frmirwrnm', e.target.checked)} />
                //     <span className="slider round"></span>
                //   </label>
                // </div>
              }
              {cnf.frmirwreml != undefined &&
                <PostToggleCard
                  className={'editor-toggle-contentwt editor-toggle-fullwt'}
                  ttl={'Show email input'}
                  fieldName={'frmirwreml'}
                  value={cnf.frmirwreml}
                  handleCnfChange={handleCnfChange}>
                  {cnf.frmirwreml == true &&
                    <div>
                      {cnf.frmrwremllbl != undefined &&
                        <div className="editor-input header-editor-ckeditor editor-header-title editor-rowbdr-none mt-0">
                          <label className="label-title">Label for email</label>
                          <ReactQuill value={cnf.frmrwremllbl} className='editor-ckeditor-input hideEditor frmrwremllbl tlsbg' modules={modulesQuill} formats={formatsQuill}
                            onChange={(newValue, delta, source) => {
                              if (source === 'user') {
                                handleCnfChange('frmrwremllbl', newValue);
                              }
                            }}
                            onFocus={() => {
                              handleEditorFocus('frmrwremllbl');
                            }} />
                        </div>
                      }
                      <div className="editor-input header-editor-ckeditor editor-header-title  mt-0" >
                        <div className="input-ctalabel input-ctalabel-dicsnt">
                          <label className="label-title">Placeholder for email</label>
                          <input className='editor-input-content editor-input-fullwidth' type="text" value={cnf.frmrwremlplchdr} onChange={(e) => handleCnfChange('frmrwremlplchdr', e.target.value)}></input>
                        </div>
                      </div>
                    </div>
                  }
                </PostToggleCard>
                // <div className="editor-toggle customize-dropdown customize-showarrow editor-rowbdr-none mt-0">
                //   <label className="label-title">Show email input</label>
                //   <label className="switch">
                //     <input type="checkbox" checked={cnf.frmirwreml} onChange={(e) => handleCnfChange('frmirwreml', e.target.checked)} />
                //     <span className="slider round"></span>
                //   </label>
                // </div>
              }


              {cnf.frmirwrphn != undefined &&
                <PostToggleCard
                  className={'editor-toggle-contentwt editor-toggle-fullwt'}
                  ttl={'Show phone input'}
                  fieldName={'frmirwrphn'}
                  value={cnf.frmirwrphn}
                  handleCnfChange={handleCnfChange}>
                  {cnf.frmirwrphn == true &&
                    <div>
                      {cnf.frmrwrphnlbl != undefined &&
                        <div className="editor-input header-editor-ckeditor editor-header-title editor-rowbdr-none mt-0">
                          <label className="label-title">Label for phone</label>
                          <ReactQuill value={cnf.frmrwrphnlbl} className='editor-ckeditor-input hideEditor frmrwrphnlbl tlsbg' modules={modulesQuill} formats={formatsQuill}
                            onChange={(newValue, delta, source) => {
                              if (source === 'user') {
                                handleCnfChange('frmrwrphnlbl', newValue);
                              }
                            }}
                            onFocus={() => {
                              handleEditorFocus('frmrwrphnlbl');
                            }} />
                        </div>
                      }
                      <div className="editor-input header-editor-ckeditor editor-header-title  mt-0">
                        <div className="input-ctalabel input-ctalabel-dicsnt">
                          <label className="label-title">Placeholder for phone</label>
                          <input className='editor-input-content editor-input-fullwidth' type="text" value={cnf.frmrwrphnplchdr} onChange={(e) => handleCnfChange('frmrwrphnplchdr', e.target.value)}></input>
                        </div>
                      </div>
                    </div>
                  }
                </PostToggleCard>
                // <div className="editor-toggle customize-dropdown customize-showarrow editor-rowbdr-none mt-0">
                //   <label className="label-title">Show phone input</label>
                //   <label className="switch">
                //     <input type="checkbox" checked={cnf.frmirwrphn} onChange={(e) => handleCnfChange('frmirwrphn', e.target.checked)} />
                //     <span className="slider round"></span>
                //   </label>
                // </div> 
              }

              {cnf.frmirtng != undefined &&
                <PostToggleCard
                  className={'editor-toggle-contentwt editor-toggle-fullwt'}
                  ttl={'Show rating section'}
                  fieldName={'frmirtng'}
                  value={cnf.frmirtng}
                  handleCnfChange={handleCnfChange}>
                  {cnf.frmrtnglbl != undefined &&
                    <div className="editor-input header-editor-ckeditor editor-header-title mt-0" style={{ display: cnf.frmirtng == true ? 'contents' : 'none' }}>
                      <label className="label-title">Label rate us</label>
                      <ReactQuill value={cnf.frmrtnglbl} className='editor-ckeditor-input hideEditor frmrtnglbl tlsbg' modules={modulesQuill} formats={formatsQuill}
                        onChange={(newValue, delta, source) => {
                          if (source === 'user') {
                            handleCnfChange('frmrtnglbl', newValue);
                          }
                        }}
                        onFocus={() => {
                          handleEditorFocus('frmrtnglbl');
                        }} />
                    </div>
                  }
                </PostToggleCard>
                // <div className="editor-toggle customize-dropdown customize-showarrow editor-rowbdr-none mt-0">
                //   <label className="label-title">Show rating section</label>
                //   <label className="switch">
                //     <input type="checkbox" checked={cnf.frmirtng} onChange={(e) => handleCnfChange('frmirtng', e.target.checked)} />
                //     <span className="slider round"></span>
                //   </label>
                // </div>
              }

              {cnf.frmirwtxt != undefined &&
                <PostToggleCard
                  className={'editor-toggle-contentwt editor-toggle-fullwt'}
                  ttl={'Show review text input'}
                  fieldName={'frmirwtxt'}
                  value={cnf.frmirwtxt}
                  handleCnfChange={handleCnfChange}>
                  {cnf.frmirwtxt == true &&
                    <div>
                      {cnf.frmrwtxtlbl != undefined &&
                        <div className="editor-input header-editor-ckeditor editor-header-title editor-rowbdr-none mt-0">
                          <label className="label-title">Label for review text</label>
                          <ReactQuill value={cnf.frmrwtxtlbl} className='editor-ckeditor-input hideEditor frmrwtxtlbl tlsbg' modules={modulesQuill} formats={formatsQuill}
                            onChange={(newValue, delta, source) => {
                              if (source === 'user') {
                                handleCnfChange('frmrwtxtlbl', newValue);
                              }
                            }}
                            onFocus={() => {
                              handleEditorFocus('frmrwtxtlbl');
                            }} />
                        </div>
                      }
                      <div className="editor-input header-editor-ckeditor editor-header-title editor-rowbdr-none  mt-0">
                        <div className="input-ctalabel input-ctalabel-dicsnt">
                          <label className="label-title">Placeholder for review text</label>
                          <input className='editor-input-content editor-input-fullwidth' type="text" value={cnf.frmrwtxtplchdr} onChange={(e) => handleCnfChange('frmrwtxtplchdr', e.target.value)}></input>
                        </div>
                      </div>
                    </div>
                  }
                </PostToggleCard>
                // <div className="editor-toggle customize-dropdown customize-showarrow editor-rowbdr-none mt-0">
                //   <label className="label-title">Show review text input</label>
                //   <label className="switch">
                //     <input type="checkbox" checked={cnf.frmirwtxt} onChange={(e) => handleCnfChange('frmirwtxt', e.target.checked)} />
                //     <span className="slider round"></span>
                //   </label>
                // </div>
              }
            </div>
          </div>
        </div>
      }
      {cnf && cnf.tlsbtntxt != undefined &&
        <div className="card card-editor card-template mt-15">
          <div className="card-editor-block card-editor-tgldflclose card-editor-rtrnvst">
            <label className="card-editor-title">Submit button</label>
            <div className="customize-list customize-cttimer-ctalabel">
              <div className="input-ctalabel input-ctalabel-dicsnt">
                <input className='editor-input-content editor-input-fullwidth' type="text" value={cnf.tlsbtntxt} onChange={(e) => handleCnfChange('tlsbtntxt', e.target.value)}></input>
              </div>
              {/* <div className="dd-ctalabel mt-4">
                <Dropdown className="nf-select-dropdown nf-select-defaultdd" options={fontSize} value={cnf.tlsbtnfntsz != undefined ? cnf.tlsbtnfntsz.toString() : cnf.tlsbtnfntsz} onChange={(e) => handleCnfChange('tlsbtnfntsz', e.value)} />
              </div> */}
            </div>
          </div>
        </div>
      }

      {/* custom height / width */}
      {cnf && cnf.irspn != undefined &&
        <CustomWidthCard
          cnf={cnf}
          handleCnfChange={handleCnfChange} />
      }
    </div>
  );
};

export default CollectorLayoutCard;


// WEBPACK FOOTER //
// ./src/components/Widget/CollectorLayoutCard.js